import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { CheckCircle2, Circle, Rocket, Database, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { API_BASE } from '@/utils/api';

// Checklist del alta en el dashboard: se muestra hasta completar todo
export const OnboardingChecklist = () => {
  const navigate = useNavigate();
  const [ob, setOb] = useState(null);
  const load = () => axios.get(`${API_BASE}/onboarding`).then(r => setOb(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  if (!ob || (ob.all_done && !ob.has_sample_data)) return null;
  const sample = async (method) => {
    if (method === 'delete' && !window.confirm('¿Borrar los datos de ejemplo? Solo se borra lo marcado como ejemplo.')) return;
    try {
      await axios({ method, url: `${API_BASE}/onboarding/sample-data` });
      toast.success(method === 'post' ? 'Datos de ejemplo cargados' : 'Datos de ejemplo borrados');
      load();
    } catch (e) { if (e.response?.status !== 402) toast.error(e.response?.data?.detail || 'No se pudo completar'); }
  };
  return (
    <div className="bg-card border border-border rounded-3xl p-5 mb-8" data-testid="onboarding-checklist">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <div>
          <h2 className="font-heading text-lg font-semibold">Puesta en marcha</h2>
          <p className="text-sm text-muted-foreground" data-testid="onboarding-progress-text">{ob.progress}% completado</p>
        </div>
        <div className="flex flex-wrap gap-2">
          {!ob.has_sample_data
            ? <Button variant="outline" size="sm" className="rounded-full" onClick={() => sample('post')} data-testid="load-sample-data-btn"><Database className="w-4 h-4 mr-1" />Cargar datos de ejemplo</Button>
            : <Button variant="outline" size="sm" className="rounded-full text-red-600" onClick={() => sample('delete')} data-testid="delete-sample-data-btn"><Trash2 className="w-4 h-4 mr-1" />Borrar datos de ejemplo</Button>}
          {!ob.all_done && <Button size="sm" className="rounded-full" onClick={() => navigate('/onboarding')} data-testid="resume-onboarding-btn"><Rocket className="w-4 h-4 mr-1" />{ob.started_at ? 'Continuar asistente' : 'Empezar asistente'}</Button>}
        </div>
      </div>
      <Progress value={ob.progress} className="h-2 mb-4" />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
        {ob.checklist.map(i => (
          <button key={i.step} onClick={() => navigate(`/onboarding?step=${i.step}`)} data-testid={`checklist-item-${i.step}`} data-done={i.done}
            className="flex items-center gap-2 text-sm px-3 py-2 rounded-xl border border-border hover:bg-muted text-left transition-colors">
            {i.done ? <CheckCircle2 className="w-4 h-4 text-green-600 shrink-0" /> : <Circle className="w-4 h-4 text-muted-foreground shrink-0" />}
            <span className={i.done ? 'line-through text-muted-foreground' : ''}>{i.label}</span>
            {i.skipped && <span className="text-[10px] text-amber-600 ml-auto">salteado</span>}
          </button>
        ))}
      </div>
    </div>
  );
};
